module.exports = __webpack_public_path__ + "img/transparencia.0c144c75.svg";